import { AnalystsForecastItemInterface } from '@shared/components/trading/info/info-stocks/common/info-stocks-analytics/common/analysts-forecast/core/interfaces/analysts-forecast-item.interface'
import { ColorCSSVarEnum } from '@shared/enums/color-css-var.enum'

export const DefaultAnalystsForecast: AnalystsForecastItemInterface[] = [
	{
		key: 'strong_buy',
		translatePath: 'analystsForecast.strongBuy',
		value: 0,
		percent: 0,
		colorVar: ColorCSSVarEnum.STATUS_SUCCESS_100,
	},
	{
		key: 'buy',
		translatePath: 'analystsForecast.buy',
		value: 0,
		percent: 0,
		colorVar: ColorCSSVarEnum.STATUS_SUCCESS_50,
	},
	{
		key: 'hold',
		translatePath: 'analystsForecast.neutral',
		value: 0,
		percent: 0,
		colorVar: ColorCSSVarEnum.STATUS_WARNING_100,
	},
	{
		key: 'sell',
		translatePath: 'analystsForecast.sell',
		value: 0,
		percent: 0,
		colorVar: ColorCSSVarEnum.STATUS_WARNING_50,
	},
	{
		key: 'strong_sell',
		translatePath: 'analystsForecast.strongSell',
		value: 0,
		percent: 0,
		colorVar: ColorCSSVarEnum.STATUS_DANGER_100,
	},
]
